import { useRouteLoaderData } from "react-router";

import { type loader as rootLoader } from "~/root";

import type { SerializeFrom } from "../types";

/**
 * @returns the request info from the root loader
 */
export function useRequestInfo() {
  const data = useRouteLoaderData("root") as SerializeFrom<typeof rootLoader>;
  return data.requestInfo;
}
